import React from 'react';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
/** overlays text to explain mature/nsfg block reasons */ const ContentFilterMiddleContent = ({ className })=>{
    return /*#__PURE__*/ React.createElement(HoverOnly, {
        reverseHidden: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(HiddenIcon, {
        size: IconSize.LARGE,
        disableDefaultColors: true
    })));
};
ContentFilterMiddleContent.displayName = 'ContentFilterMiddleContent';
export default ContentFilterMiddleContent;
